export function getStrikeAndType(positionSymbol: string): string {
  let optionDetails;
  const regex = /\d/;
  for (let i = 0; i < positionSymbol.length; i++) {
    if (regex.test(positionSymbol[i])) {
      positionSymbol.slice(0, i);
      optionDetails = positionSymbol.slice(i);
      break;
    }
  }
  let date;
  let strikeDetails;
  for (let i = 0; i < optionDetails.length; i++) {
    if (!regex.test(optionDetails[i])) {
      date = optionDetails.slice(0, i);
      strikeDetails = optionDetails.slice(i);
      break;
    }
  }

  const monthAndDay = date.slice(2);
  let month = monthAndDay.slice(0, 2);
  let day = monthAndDay.slice(2);
  if(month[0] === '0') month = monthAndDay.slice(1, 2);
  if(day[0] === '0') day = monthAndDay.slice(3);
  const callOrPutt = strikeDetails[0];
  const strike = strikeDetails.slice(1);
  const cleanStrike = strike.replace(/^0+/, '');
  const decimals = cleanStrike.slice(cleanStrike.length - 3).replace(/0+$/, '');
  const strikeResult =
    cleanStrike.slice(0, cleanStrike.length - 3) +
    (decimals.length > 0 ? '.' + decimals : '');
  return strikeResult + ' ' + callOrPutt + ' ' + month + '/' + day;
}
